export enum CHAT_ROLE {
    '用户' = 1,
    '助手' = 2,
}
